import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import Vuelidate from 'vuelidate'
import VueMeta from 'vue-meta'
import VueLazyload from 'vue-lazyload'
import VueAnalytics from 'vue-analytics'
import HighchartsVue from 'highcharts-vue'
import VueSession from 'vue-session'

Vue.use(VueAnalytics, {
    id: 'G-KZ4JBBHNRD',
    router,
})
Vue.use(VueLazyload, {
    preLoad: 1.3,
    loading: '/img/Spinner.gif',
    attempt: 1,
})

Vue.use(VueSession)
Vue.use(VueMeta)
Vue.use(Vuelidate)
Vue.use(Buefy)
Vue.use(HighchartsVue)

Vue.config.productionTip = false

require('./assets/main.scss')

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
